<template>
  <!-- <img id="logo-context" :src="require(`@/assets/Logo/default-${themeVal}.png`)"> -->
  <img id="logo-context" :src="require(`@/assets/Logo/default-${theme || themeVal}.png`)">
</template>

<script setup>
import { 
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick
} from 'vue';
import { isNull, dayjs, message } from '@/utils/js/initVariable';
import store from '@/store';

// props
const props = defineProps({
  theme: { type: String, },
});
// emit
const emit = defineEmits([
  
]);
const themeVal = computed(()=> store.getters['themeScheme/getThemeVal'] );

// 组件挂载前
onBeforeMount(()=>{

});
// 组件挂载后
onMounted(()=>{

});
// 组件更新后
onUpdated(()=>{

});
// 组件销毁后
onUnmounted(()=>{

});

</script>

<style lang='less'>

</style>

<style lang='less' scoped>
#logo-context{
  // width: 100%;
  height: 100%;
  vertical-align: middle;
}
</style>